export default __webpack_public_path__ + "static/media/img13.28b1f4df.png";